(() => {
	const BTN = '[data-load-more]';

	// Findet das Produktraster: Cascade-Layout ODER normales Raster (grid--uniform).
	// Gesucht wird nur innerhalb von #main-collection-product-grid, damit weitere
	// Cascade-Sections auf der Seite (z. B. Textblöcke unter dem Raster) nicht getroffen werden.
	const findGrid = (root) => {
		const scope = root.querySelector('#main-collection-product-grid');
		if (!scope) return null;
		const cascade = scope.querySelector('cascading-content.items');
		if (cascade) {
			return { el: cascade, isCascade: true, items: [...cascade.querySelectorAll(':scope > .item')] };
		}
		const uniform = scope.querySelector('.grid--uniform');
		if (uniform) {
			return { el: uniform, isCascade: false, items: [...uniform.querySelectorAll(':scope > .grid__item')] };
		}
		return null;
	};

	// Button zeigen, klassische Pagination ausblenden (läuft auch nach Filter-/Sortier-Reloads erneut)
	const enhance = () => {
		document.querySelectorAll('[data-load-more-wrap]').forEach(el => { el.hidden = false; });
		document.querySelectorAll('[data-pagination-fallback]').forEach(el => { el.hidden = true; });
	};
	enhance();
	new MutationObserver(enhance).observe(document.getElementById('MainContent') || document.body, {
		childList: true,
		subtree: true
	});

	document.addEventListener('click', async (e) => {
		const btn = e.target.closest(BTN);
		if (!btn || btn.getAttribute('aria-busy') === 'true') return;
		e.preventDefault();

		const label = btn.textContent;
		btn.setAttribute('aria-busy', 'true');
		btn.textContent = 'Lädt …';

		// Scrollposition merken, damit die Seite beim Nachladen nicht springt
		const x = window.scrollX;
		const y = window.scrollY;
		const target = findGrid(document);
		const holder = target && target.isCascade ? target.el.parentElement : null;

		try {
			const res = await fetch(btn.href, { credentials: 'same-origin' });
			if (!res.ok) throw new Error(res.status);
			const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

			const source = findGrid(doc);
			if (!target || !source || target.isCascade !== source.isCascade) throw new Error('grid not found');

			const nextBtn = doc.querySelector(BTN);

			if (target.isCascade) {
				// Höhe während der Neuberechnung fixieren, damit die Seite nicht kurz "zusammenfällt"
				holder.style.minHeight = holder.getBoundingClientRect().height + 'px';
				// item--last der bisherigen Seite entfernen
				target.el.querySelectorAll('.item--last').forEach(i => i.classList.remove('item--last'));
			}

			source.items.forEach(item => {
				if (target.isCascade) {
					item.classList.remove('item--first');
					if (nextBtn) item.classList.remove('item--last'); // nur auf der letzten Seite behalten
				}
				target.el.appendChild(document.importNode(item, true));
			});

			if (target.isCascade) {
				// Cascade-Layout neu berechnen, danach Einblend-Status wiederherstellen
				target.el.cascade.deinit();
				target.el.cascade.init();
				target.el.querySelectorAll(':scope > .item').forEach(i => i.classList.add('ready', 'activated'));
				// Scrollposition wiederherstellen, Höhenfixierung danach lösen
				window.scrollTo(x, y);
				requestAnimationFrame(() => {
					window.scrollTo(x, y);
					holder.style.minHeight = '';
				});
			}

			if (nextBtn) {
				btn.href = nextBtn.href;
				btn.textContent = label;
				btn.removeAttribute('aria-busy');
			} else {
				btn.closest('[data-load-more-wrap]').remove();
			}
		} catch (err) {
			console.error('Load more failed', err);
			if (holder) holder.style.minHeight = '';
			window.location.href = btn.href; // Fallback: normale Seitennavigation
		}
	});
})();
